export default __webpack_public_path__ + "static/media/token_left.19a7a8d5.png";